var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('h2',[_vm._v("Offices")]),_c('v-text-field')],1)}
var staticRenderFns = []

export { render, staticRenderFns }